export class ProcurementDashboardService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? ProcurementDashboardService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${ProcurementDashboardService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    async getMyStats() {
        const response = await this.http.get(this.buildUrl('my-stats'));
        return response.data;
    }
    async getMyRoles() {
        const response = await this.http.get(this.buildUrl('my-roles'));
        return response.data ?? [];
    }
}
ProcurementDashboardService.DEFAULT_SERVICE_PATH = 'procurements';
ProcurementDashboardService.BASE_PATH = 'api/procurement-portal/dashboard';
//# sourceMappingURL=ProcurementDashboardService.js.map